import type { NationId } from "@cwb/core";
import { useGameStore } from "../stores/gameStore";

/**
 * Which nation the order book is pointed at.
 *
 * A nation is chosen on the map — clicking a province selects its owner — so
 * this only reads that choice. The dossier is a separate question, answered by
 * whatever the pointer is over rather than by a selection.
 */

/** Selection falls back to whoever is fighting, because that is the interesting one. */
export function useActiveNationId(): NationId | null {
  return useGameStore((s) => {
    if (s.selectedNationId) return s.selectedNationId;
    const nations = s.state?.nations ?? [];
    const fighting = nations.find((n) => !n.eliminated && n.atWarWith.length > 0);
    if (fighting) return fighting.id;
    return nations.find((n) => !n.eliminated)?.id ?? null;
  });
}
